import { WorkflowProcessDrawerParentSteps } from './types';
import { WorkflowProcessParentStep } from './WorkflowProcessParentStep';

const WorkflowProcessParentSteps = ({
  steps,
  activeStep,
  setActiveStep,
  hideHeader = false,
  renderButton,
}: {
  steps: WorkflowProcessDrawerParentSteps[];
  activeStep: WorkflowProcessDrawerParentSteps;
  setActiveStep: (step: WorkflowProcessDrawerParentSteps) => void;
  hideHeader?: boolean;
  renderButton?: () => React.ReactNode;
}) => {
  return (
    <div className="flex flex-col  border-r-2 border-r-border-primary h-[calc(100vh-64px)]">
      {!hideHeader && (
        <div className="py-1.5 pl-6 pr-3 flex justify-between items-center border-b border-b-border-primary h-12">
          <span className="txt-small-medium">
            {steps.length} {steps.length === 1 ? 'service' : 'services'}
          </span>
        </div>
      )}
      <div className="flex flex-col overflow-y-auto flex-1 bg-bg-primary">
        {steps.map((step) => (
          <WorkflowProcessParentStep
            key={step.key}
            onClick={() => setActiveStep(step)}
            isActive={step.key === activeStep.key}
            step={step}
          />
        ))}

        {renderButton && renderButton()}
      </div>
    </div>
  );
};

export { WorkflowProcessParentSteps };
